module.exports = __webpack_public_path__ + "img/vertical_7_1_3009.06f491a8.png";